import styled from "styled-components"
import theme from "styles/theme-main"
import Text from "components/Text"
import { media } from "utils/utils"

export const Wrapper = styled.div`
  display: flex;
  justify-content: ${props =>
    props.justifyContent ? props.justifyContent : "flex-start"};
  align-items: center;
`

export const ControlWrapper = styled.div`
  display: flex;
  width: 300px;
  max-width: 100%;
  margin-right: ${props => (props.noMargin ? "0" : "15px")};
  position: relative;

  ${media.md`
    width: 100%;
    flex-direction: column;
  `};
`

export const Label = styled(Text)`
  display: inline-block;
  font-weight: bold;

  ${media.sm`
    line-height: 17px;
  `};
`

export const LabelContainer = styled.div`
  display: ${props => (props.hasHint ? "inline-block" : "block")};
  margin-right: ${props => (props.margin ? "10px" : "0")};
  text-align: right;

  ${media.sm`
    margin-right: 4px;
  `};
`

export const Hint = styled(Text)`
  margin-bottom: 9px;
  display: inline-block;
`

export const ErrorMessage = styled.div`
  position: absolute;
  left: ${props =>
    props.displayErrorBottom
      ? "0px"
      : props.width
      ? props.width
      : theme.widths[props.size]};
  display: inline-flex;
  justify-content: flex-start;
  align-items: flex-start;
  text-align: left;
  margin-left: ${props => props.hasRemoveButton};
  margin-top: ${props => (props.displayErrorBottom ? "50px" : props.topMargin)};
  width: 317px;

  ${media.md`
    position: static;
  `};
`

export const SubHeading = styled(Text)`
  display: ${props => (props.inlineLabels ? "inline-block" : "block")}
  margin-left: ${props => (props.inlineLabels ? "10px" : 0)}
  margin-bottom: 14px;
`

export const OptionalWrapper = styled.div`
  display: inline-block;
`
